module.exports = __webpack_public_path__ + "media/images/trashicon-7aa00908.png";